import { useAuthStore } from '@/stores/authenticated/AuthStore'
import axios from 'axios'

const axiosInstance = axios.create({
  timeout: import.meta.env.VITE_API_TIMEOUT ?? 30000,
  headers: {
    'X-Frontend': 'ENG_APP',
  },
})

axiosInstance.interceptors.response.use(undefined, async (err) => {
  if (err && err.response && (err.response.status === 401 || err.response.status === 403)) {
    const authStore = useAuthStore()
    await authStore.logout()

    window.location.href = '/'
  }

  return Promise.reject(err)
})

export function setBearerToken(token) {
  if (token) {
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`
  } else {
    delete axiosInstance.defaults.headers.common['Authorization']
  }
}

export default {
  install(app) {
    app.provide('$axios', axiosInstance)
    app.config.globalProperties.$axios = axiosInstance
  },
}

export { axiosInstance }
